(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.home.championships.newChampionship
   * @description
   *
   */
  angular
    .module('neo.home.championships.newChampionship', [
      'ui.router'
    ]);
}());
